// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "map" + "." + "c518e3d16b57dec790ca" + ".min.css";
};